import type { ReactNode } from 'react';

import { Settings2 } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';
import { Button } from '@nesso/ui/primitives/button';
import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@nesso/ui/primitives/dialog';

interface Props {
    open: boolean;
    disabled: boolean;
    onOpenChange: (open: boolean) => void;
    save: () => void;
    reset: () => void;
    children: ReactNode;
}

export function EditSessionNoteSettingsDialog({
    open,
    onOpenChange,
    disabled,
    save,
    reset,
    children,
}: Props) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogTrigger asChild>
                <Button
                    variant="outline"
                    size="icon"
                    aria-label="Customize Note"
                    disabled={disabled}
                    className={cn(open && 'bg-accent text-accent-foreground')}
                >
                    <Settings2 className="w-4 h-4" />
                </Button>
            </DialogTrigger>

            <DialogContent fullscreen showCloseButton={false} onEscapeKeyDown={() => reset()}>
                <DialogHeader className="p-6 text-left">
                    <DialogTitle>Customize Note</DialogTitle>
                </DialogHeader>

                {children}

                <DialogFooter className="flex-row gap-2 p-6">
                    <Button
                        variant="outline"
                        className="flex-1"
                        onClick={() => {
                            reset();
                            onOpenChange(false);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="flex-1"
                        onClick={() => {
                            save();
                            onOpenChange(false);
                        }}
                    >
                        Update
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
